import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
    FacebookShareButton,
    FacebookShareCount,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    PinterestShareButton,
    PinterestShareCount,
    PinterestIcon
} from 'react-share';
import { getRecipeFromDB } from './../../../AwsFunctions';
import './Recipe.css';

function Recipe() {

    let { recipeId } = useParams();
    const [recipe, setRecipe] = useState({});

    useEffect(() => {
        getRecipeFromDB(recipeId).then(data => {
            if (data && Object.keys(data).length !== 0) {
                setRecipe(data);
            }
        });
    }, [recipeId]);

    function timeSchema(time) {
        if (time !== undefined) {
            const array = time.split(' ');
            let unit;
            if (array[1].substring(0, 1) === 'm') {
                unit = 'M';
            } else if (array[1].substring(0, 1) === 'h') {
                unit = 'H';
            }
            return array[0] + unit;
        }
    }

    return (
        <>
            <Helmet>
                <title>{'Kai Cheng | ' + recipe.title + ' recipe'}</title>
                <meta name='description' content={'Kai Cheng | ' + recipe.description} />
                <link rel='canonical' href={'https://www.kaicheng.ca' + recipe.path} />
            </Helmet>
            <div className='recipe' itemScope itemType='http://schema.org/Recipe'>
                <div className='summary'>
                    <div className='col-60'>
                        <h1 className='title' itemProp='name'>{recipe.title}</h1>
                        <div className='author'>
                            By <span itemProp='author' itemScope itemType='http://schema.org/Person'>
                                <span itemProp='name'>Kai Cheng</span>
                            </span>
                        </div>
                        <div className='description' itemProp='description'>{recipe.description}</div>
                        <div className='other'>
                            <span>Prep: <time content={'PT' + timeSchema(recipe.prepTime)} itemProp='prepTime'>{recipe.prepTime}</time> | </span>
                            <span>Cook: <time content={'PT' + timeSchema(recipe.cookTime)} itemProp='cookTime'>{recipe.cookTime}</time> | </span>
                            <span>Total Time: <time content={'PT' + timeSchema(recipe.totalTime)} itemProp='totalTime'>{recipe.totalTime}</time></span>
                            <div>Servings: <span itemProp='recipeYield'>{recipe.servings}</span></div>
                            <div className='socialActivity'>
                                <div className='socialShare facebookShare'>
                                    <FacebookShareButton
                                        url={'https://www.kaicheng.ca' + recipe.path}
                                        quote={recipe.title}
                                        hashtag={'#' + recipe.labels}>
                                        <FacebookIcon size={36} borderRadius='10' />
                                    </FacebookShareButton>
                                    <FacebookShareCount url={'https://www.kaicheng.ca' + recipe.path}>
                                        {shareCount => <span className='myShareCountWrapper'>{shareCount}</span>}
                                    </FacebookShareCount>
                                </div>
                                <div className='socialShare twitterShare'>
                                    <TwitterShareButton
                                        url={'https://www.kaicheng.ca' + recipe.path}
                                        title={recipe.title}
                                        via='kaichengster'
                                        hashtags={recipe.labels}>
                                        < TwitterIcon size={36} borderRadius='10' />
                                    </TwitterShareButton>
                                </div>
                                <div className='socialShare pinterestShare'>
                                    <PinterestShareButton
                                        url={'https://www.kaicheng.ca' + recipe.path}
                                        media={'https://www.kaicheng.ca' + recipe.img}
                                        description={recipe.title}>
                                        <PinterestIcon size={36} borderRadius='10' />
                                    </PinterestShareButton>
                                    <PinterestShareCount url={'https://www.kaicheng.ca' + recipe.path}>
                                        {shareCount => <span className='myShareCountWrapper'>{shareCount}</span>}
                                    </PinterestShareCount>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-40'>
                        <img className='icon' src={recipe.img} alt={recipe.title} itemProp='image' />
                    </div>
                </div>
                <div className='details'>
                    <div className='ingredients col-40'>
                        <h2 className='title'>Ingredients</h2>
                        {recipe.ingredients != null && Object.keys(recipe.ingredients).map((key) => (
                            <div key={key}>
                                {Object.keys(recipe.ingredients).length > 1 &&
                                    <h3 className='subTitle'>{key}</h3>
                                }
                                <ul>
                                    {recipe.ingredients[key].map((value, index) => (
                                        <li key={index}>
                                            <input type='checkbox' name={value.ingredientName} value={value.ingredientName} /> {value.ingredientAmount} <span itemProp='recipeIngredient'>{value.ingredientName}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                    <div className='directions col-60'>
                        <h2 className='title'>Directions</h2>
                        <ul itemProp='recipeInstructions'>
                            {recipe.instructions != null && recipe.instructions.map((value, index) => (
                                <li key={index}>{value}</li>
                            ))}
                        </ul>
                    </div>
                    {recipe.notes != null &&
                        <div className='notes'>
                            <h2 className='title'>Notes</h2>
                            <span>{recipe.notes}</span>
                        </div>
                    }
                </div>
            </div>
        </>
    );
}

export default Recipe;
